<template>
  <button @click.stop="$emit('click')" :style="{backgroundColor: bg}"
 ><div v-if="icon" :style="{maskImage: `url(./svg/btn/${icon}.svg)`}"></div>{{text}}</button>
</template>

<script>
export default {
  props: ['icon', 'text', 'bg']

}
</script>

<style lang="scss" scoped>
button {
  padding: 0 20px;
  height: 50px;
  color: #FFFFFF;
  border-radius: 25px;
  letter-spacing: 0.1em;
  font-weight: 400;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
  &>div{
    width: 25px;
    height: 25px;
    background-color: #FFFFFF;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
  }
}
</style>
